import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import { ProductKey, TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useLocation } from "@/utils/location-provider";

import { GetStartedText, Headings } from "../../components";

export const LoggedOut = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const primaryCollectionProduct = params.get("primaryCollectionProduct");
    let heading: React.ReactNode = (
        <Headings
            main={<GetStartedText productName="Teamwork Collection" />}
            sub={
                <FormattedMessage
                    id="signup.teamworkCollection.subHeading"
                    defaultMessage="It's free for up to 10 users - no credit card needed."
                />
            }
        />
    );

    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    if (primaryCollectionProduct === ProductKey.ROVO) {
        heading = (
            <Headings
                main={
                    <FormattedMessage
                        id="signup.teamworkCollection.rovoHeading"
                        defaultMessage="Get Teamwork Collection to start using Rovo"
                    />
                }
                sub={
                    <FormattedMessage
                        id="signup.teamworkCollection.rovoSubHeading"
                        defaultMessage="Free for up to ten users. Start using Rovo in 20 minutes or less after sign-up."
                    />
                }
            />
        );
    }

    const content = (
        <>
            {heading}
            <AccountCreation />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
